import { isDefined } from "@omni/utils/helper.utils";

import { clearMessageById } from "@/redux/modules/value/messages/messages.utils";
import { useWoosmapServices } from "@/utils/hooks/useWoosmapServices.hook";

import {
    SearchItem,
    SearchItemType
} from "../StoreSearchInput/storeSearchInput.types";
import StoreLocatorMobile from "./storeLocatorMobile.component";
import { STORE_LOCATOR_MOBILE_MESSAGE_ID } from "./storeLocatorMobile.config";

export type StoreLocatorMobileContainerProps = {
    link: string;
};

export const StoreLocatorMobileContainer = ({
    link
}: StoreLocatorMobileContainerProps) => {
    const { LocalitiesService } = useWoosmapServices();

    const handleOnUseLocation = (latitude: number, longitude: number) => {
        clearMessageById(STORE_LOCATOR_MOBILE_MESSAGE_ID);

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("latitude", latitude.toString());
        queryParams.set("longitude", longitude.toString());

        window.location.assign(`${link}?${queryParams.toString()}`);
    };

    const handleOnSelect = async (searchItem: SearchItem | null) => {
        clearMessageById(STORE_LOCATOR_MOBILE_MESSAGE_ID);

        if (!searchItem) return;

        const queryParams = new URLSearchParams(window.location.search);

        if (searchItem.type === SearchItemType.Store) {
            queryParams.set("storeId", searchItem.value);
        } else if (isDefined(LocalitiesService)) {
            const details = await LocalitiesService.getDetails({
                publicId: searchItem.value
            });

            const coordinates = details.result.geometry?.location;

            if (coordinates) {
                queryParams.set("latitude", coordinates.lat.toString());
                queryParams.set("longitude", coordinates.lng.toString());
            }
        }

        window.location.assign(`${link}?${queryParams.toString()}`);
    };

    const handleOnSubmitClick = (value?: string) => {
        if (!value) return;

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("query", value);

        window.location.assign(`${link}?${queryParams.toString()}`);
    };

    return (
        <StoreLocatorMobile
            onUseLocation={handleOnUseLocation}
            onSelect={handleOnSelect}
            onSubmitClick={handleOnSubmitClick}
        />
    );
};
